import CostumCarousel from "../CostumCarousel";
import Support from './../Supports';
import Faq from './../FAQ'
import Reserve from "../Reservation";


const MobileHome = () => {
        return ( <>
                <CostumCarousel/>
                <Reserve/>
                <Support/>
                {/* <Faq/> */}
        </> );
}
 
export default MobileHome;